import { cn } from "@/lib/utils";

interface SectionDescriptionProps {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "light" | "blue";
}

export const SectionDescription = ({
  children,
  className,
  variant = "default",
}: SectionDescriptionProps) => {
  const variantStyles = {
    default: "text-text-color",
    light: "text-background",
    blue: "text-primary-blue",
  };

  return (
    <p
      className={cn(
        "font-inter font-normal text-[16px] leading-[150%] lg:text-[18px]",
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </p>
  );
};
